import { render } from "./ModalJy.vue?vue&type=template&id=6cefdd77&scoped=true"
import script from "./ModalJy.vue?vue&type=script&lang=js"
export * from "./ModalJy.vue?vue&type=script&lang=js"

import "./ModalJy.vue?vue&type=style&index=0&id=6cefdd77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cefdd77"]])

export default __exports__